import { Inject, Injectable, Injector } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

import { AUTH_INTERCEPTOR_HEADER, AuthJWTToken, AuthService } from "@edpc/edp-auth";

import { CookieService } from "ngx-cookie-service";
import { EnvService } from "@edp-services/env.service";

@Injectable()
export class EdpAuthInterceptor implements HttpInterceptor {
    constructor(
        private injector: Injector,
        private cookieService: CookieService,
        @Inject(AUTH_INTERCEPTOR_HEADER)
        protected headerName: string = "Authorization",
        private envService: EnvService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.authService.getToken().pipe(
            switchMap((token: AuthJWTToken) => {
                if (token && token.getValue()) {
                    const auth_token = token.getValue();
                    let headers = {
                        [this.headerName] : auth_token,
                    };

                    // set token cookies
                    if ( !this.cookieService.get("X-Auth-Token")) {
                        const now = new Date();
                        now.setTime(now.getTime() + 1 * 1800 * 1000);
                        this.cookieService.set("X-Auth-Token", auth_token, now, "/", this.envService.getCookieDomain(), true);
                    }
                    if ( this.cookieService.get("is_impersonate")) {
                        headers = {...headers, ...{["Impersonate"]: "true"}};
                    }

                    req = req.clone({
                        setHeaders: headers,
                    });
                }
                return next.handle(req);
            })
        );
    }

    protected get authService(): AuthService {
        return this.injector.get(AuthService);
    }
}
